export const interceptConnections = (original, interceptor) => {
    original.connect = ((destination, output = 0, input = 0) => {
        if (destination instanceof AudioNode) {
            // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
            interceptor.connect.call(interceptor, destination, output, input);
            // Bug #11: Safari does not support chaining yet.
            return destination;
        }
        // @todo TypeScript does still assume that connect() returns void.
        return interceptor.connect.call(interceptor, destination, output);
    });
    original.disconnect = function () {
        // @todo TypeScript cannot infer all the signatures yet.
        interceptor.disconnect.apply(interceptor, arguments);
    };
    return original;
};
//# sourceMappingURL=/build/es2018/helpers/intercept-connections.js.map